(function () {
  if (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) return;

  var ring = document.createElement('div');
  ring.className = 'sovyer-cursor-ring';
  ring.setAttribute('aria-hidden', 'true');
  document.body.appendChild(ring);

  var mouseX = window.innerWidth / 2;
  var mouseY = window.innerHeight / 2;
  var ringX = mouseX;
  var ringY = mouseY;
  var visible = false;

  window.addEventListener('mousemove', function (e) {
    mouseX = e.clientX;
    mouseY = e.clientY;
    if (!visible) {
      visible = true;
      ring.style.opacity = '1';
    }
  }, { passive: true });

  document.addEventListener('mouseleave', function () {
    visible = false;
    ring.style.opacity = '0';
  });

  var hoverSelector = 'a, button, .button, input, textarea, select, [role="button"], summary';
  document.addEventListener('mouseover', function (e) {
    if (e.target && e.target.closest && e.target.closest(hoverSelector)) {
      ring.classList.add('is-hovering');
    }
  });
  document.addEventListener('mouseout', function (e) {
    if (e.target && e.target.closest && e.target.closest(hoverSelector)) {
      ring.classList.remove('is-hovering');
    }
  });

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function tick() {
    if (reduceMotion) {
      ringX = mouseX;
      ringY = mouseY;
    } else {
      ringX += (mouseX - ringX) * 0.18;
      ringY += (mouseY - ringY) * 0.18;
    }
    ring.style.transform = 'translate(' + ringX + 'px, ' + ringY + 'px) translate(-50%, -50%)';
    window.requestAnimationFrame(tick);
  }
  window.requestAnimationFrame(tick);
})();
